import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_VALUE_CONFIG } from "@nexus/widget-kit";
import { BREAKDOWNS } from ".";

/** What an author sets on the safe-to-block summary. */
export const settings = defineWidgetSettings({
  id: "safe-to-block",
  extends: [ANIMATE_VALUE_CONFIG],
  properties: {
    breakdown: {
      type: "string",
      title: "Breakdown",
      description:
        "Rows under the safety bar: Web and IPTV safety, or the share approved by the regulator",
      default: "channels",
      oneOf: BREAKDOWNS.map((option) => ({ const: option.value, title: option.label })),
      "x-ui": { category: "data", order: 10 },
    },
  },
});
